import { SharedValue, useDerivedValue } from "react-native-reanimated";

import React, { useMemo } from "react";
import { useWidgetMargin } from "../Widget/useWidgetMargin";
import { getFixedLeftPositionWorklet } from "../worklets/getFixedLeftPositionWorklet";

import { graphql, PreloadedQuery, usePreloadedQuery } from "react-relay";
import { WidgetNoteEditQuery } from "./__generated__/WidgetNoteEditQuery.graphql";
import { NoteEdit } from "./NoteEdit";
import { useUploadWidgetNoteImage } from "./useSaveNoteImage";

export type { WidgetNoteEditQuery };
export const WIDGET_NOTE_EDIT_QUERY = graphql`
  query WidgetNoteEditQuery($id: ID!) {
    widgetNote(id: $id) @required(action: THROW) {
      positionY
      positionX
      note {
        ...NoteEditSharedInfo_widgetNote
        ...NoteEdit
      }
    }
  }
`;

type Props = {
  queryRef: PreloadedQuery<WidgetNoteEditQuery>;
  columnHorizontalPadding: number;
  pageId: string;
  onClosed(): void;
  onStart(): void;
  left?: number;
  top?: number;
  scrollX: SharedValue<number>;
  unitSize: number;
  headerHeight: number;
};

export function WidgetNoteEdit(props: Props) {
  const data = usePreloadedQuery<WidgetNoteEditQuery>(
    WIDGET_NOTE_EDIT_QUERY,
    props.queryRef
  );

  const margin = useWidgetMargin();
  const top = useMemo(
    () =>
      props.top !== undefined
        ? props.top
        : props.headerHeight +
          margin +
          data.widgetNote.positionY * props.unitSize,
    [
      data.widgetNote.positionY,
      props.headerHeight,
      margin,
      props.top,
      props.unitSize,
    ]
  );

  const left = useDerivedValue(() =>
    getFixedLeftPositionWorklet({
      positionX: data.widgetNote.positionX,
      scrollX: props.scrollX.value,
      columnHorizontalPadding: props.columnHorizontalPadding,
      unitSize: props.unitSize,
      margin,
    })
  );

  const [uploadImage] = useUploadWidgetNoteImage();

  return (
    <NoteEdit
      uploadImage={uploadImage}
      note={data.widgetNote.note}
      onClosed={props.onClosed}
      onStart={props.onStart}
      pageId={props.pageId}
      unitSize={props.unitSize}
      startLeft={left}
      startTop={top}
    />
  );
}
